import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Move keyboard / screen-reader focus to a sensible landing point on every
// route change. Without this, users who navigate by keyboard end up stuck
// wherever the previous page left their focus — usually a nav link in the
// header — and screen readers don't announce the new page.
//
// Strategy: find the first <main> in the document, give it tabIndex={-1}
// so it's programmatically focusable, focus it. Skips the very first mount
// (the browser already focused something on initial load).
export default function RouteAnnouncer() {
  const { pathname } = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    const main = document.querySelector('main');
    if (!main) return;
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: true });
  }, [pathname]);

  return null;
}
